import axios from "axios";
import { isNative, getNativeToken } from "@/lib/native";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
if (!backendUrl) throw new Error("REACT_APP_BACKEND_URL is required");
export const API = `${backendUrl.replace(/\/$/, "")}/api`;
export const http = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "X-Skinly-Request": "1" },
});

// In the native WebView the API is a different origin, so the session cookie
// cannot be used: the token travels in the Authorization header instead.
http.interceptors.request.use(async (config) => {
  if (isNative()) {
    config.headers["X-Skinly-Client"] = "native";
    const token = await getNativeToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Retire the legacy browser-readable token. Existing users sign in once again.
if (typeof window !== "undefined") localStorage.removeItem("mounjaro_token");

export const formatApiError = (error, fallback = "Erro") => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg).filter(Boolean).join(". ");
  return error?.message || fallback;
};

export const handle = (promise) => promise.then((response) => response.data).catch((cause) => {
  const error = new Error(formatApiError(cause));
  error.status = cause?.response?.status;
  error.response = cause?.response;
  throw error;
});

export const photoUrl = (path) => new URL(new URL(path, backendUrl).pathname, backendUrl).href;